<template>
  <div>
    <div
      class="more"
      @click="openDialog"
    >
      <i class="el-icon-circle-plus-outline" />
      <span>添加</span>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
    >
      <optionSelets
        title="您关注的行业（可多选）"
        :opts="opts.industry"
        :checked.sync="focusIndustry"
        :limit="limit.industry"
      />
      <optionSelets
        title="您关注的风险（可多选）"
        :opts="opts.category"
        :checked.sync="focusCategory"
        :limit="limit.category"
      />
      <div class="footer">
        <el-button
          size="small"
          type="primary"
          @click="confirm"
        >确 定</el-button>
        <el-button
          size="small"
          @click="dialogVisible = false"
        >取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import client from '@index/server/server'
import optionSelets from './optionSelets.vue'
export default {
  name: 'ChooseIndustryAndRiskDialog',
  components: { optionSelets },
  data () {
    return {
      dialogVisible: false,
      opts: {
        industry: [],
        category: []
      },
      focusIndustry: [],
      focusCategory: []
    }
  },
  props: {
  },
  computed: {
    limit () {
      console.log('this.$store.getters.userLimit,', this.$store.getters.userLimit)
      return this.$store.getters.userLimit
    }
  },
  watch: {
  },
  created () {
    this.getFocusOptions()
  },
  methods: {
    confirm () {
      client.PutIndexUpdateFocus(
        {
          industryList: this.focusIndustry,
          categoryList: this.focusCategory
        }
      ).then(res => {
        if (res.success) {
          this.$store.dispatch('GetUserinfo')
          this.$message.success(res.message)
          this.dialogVisible = false
          // this.$router.go(0)
        }
      })
    },
    openDialog () {
      this.focusIndustry = this.$store.state.user.userinfo.focusIndustryList
      this.focusCategory = this.$store.state.user.userinfo.focusCategoryList
      this.dialogVisible = true
    },
    getFocusOptions () {
      client.GetIndexFocusOptions().then(res => {
        if (res.success) {
          const { industryList, categoryList } = res.data
          // 暂时隐藏战略风险
          categoryList.splice(categoryList.indexOf('战略风险'), 1)
          // 将【消费】放到第一位
          industryList.splice(industryList.indexOf('消费'), 1)
          industryList.unshift('消费')
          this.opts.industry = industryList
          this.opts.category = categoryList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  margin: 20px 0;
  text-align: center;
}
.more {
  color: #347eee;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  cursor: pointer;
  & > i {
    font-size: 16px;
    margin-right: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/ChooseIndustryAndRiskDialog/ChooseIndustryAndRiskDialog.vue